export default __webpack_public_path__ + "static/media/Tasset of the Berserker's Fury.bf3cb876.jpg";